import ReviewCard from './ReviewCard';

export default function ResultsGrid({ results }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-max">
      {results.map((result) => (
        <ReviewCard key={result.id} result={result} />
      ))}
    </div>
  );
}
